module.exports = __webpack_public_path__ + "static/media/partner_ads.57254a8c.svg";